import { Stack } from "@mui/material";
import { Icon } from "components/Icon";
import { StatusChip } from "features/shared/components/StatusChip";
import { useTranslation } from "react-i18next";

export const EpcIntroPhase = () => {
  const { t } = useTranslation();
  return (
    <Stack className="w-full flex-col items-stretch gap-4">
      <StatusChip className="self-start" variant="neutral">
        {t("AddBuilding.epcModal.optionalBadge").toUpperCase()}
      </StatusChip>
      <Stack className="w-full flex-col items-center gap-4 text-center">
        <StatusChip className="rounded-full border-none p-2" variant="info">
          <Icon className="" iconName="Award" size="2xl" />
        </StatusChip>
        <h2 className="font-ds-headline-lg">{t("AddBuilding.epcModal.introTitle")}</h2>
        <p className="max-w-[40rem] text-lds-foreground-muted font-ds-body-regular-md">
          {t("AddBuilding.epcModal.introDescription")}
        </p>
      </Stack>
      <p className="w-full text-center text-lds-foreground-muted font-ds-body-regular-xs">
        {t("AddBuilding.epcModal.introFooter")}
      </p>
    </Stack>
  );
};
